module.exports = __webpack_public_path__ + "media/images/front/personalIcon-289dd6ea91bb5ef9a295cb6f821cd78e.svg";